import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  currentIndex: 0
}

export default new Vuex.Store({
    state,
    mutations: {
      currentIndexChange (value, payload) {
        state.currentIndex = payload
      }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js